import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import { Typography, Button, Stack } from "@mui/material";
import { generateGtmEvent } from "../../../Helpers";

const useStyles = makeStyles((theme) => ({
  dialogRoot: {
    backgroundColor: "transparent",
  },
  newPosOfDialog: {
    padding: 32,
    maxWidth: 500,
    minHeight: 200,
    backgroundColor: "#FFFFFF",
    border: `2px solid ${theme.palette.divider}`,
    borderRadius: 15,
  },
  dialogTitle: {
    marginBottom: "24px",
  },
  dialogText: {
    marginBottom: "33px",
  },

  buttonNo: {
    width: 210,
    padding: 0,
    backgroundColor: "#D8D8D8",
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: "#C9C8C8",
    },
  },
  buttonYes: { width: 210, padding: 0 },
}));

export interface SubmitReminderProps {
  promptOpen: boolean;
  promptOnClose: () => void;
  promptOnContinue: () => () => void;
}

export const WrapperSubmitReminder = (props: SubmitReminderProps) => {
  const classes = useStyles();
  const { promptOnClose, promptOpen, promptOnContinue } = props;

  const handleDismissPrompt = () => {
    promptOnClose();
  };

  const handleContinue = () => {
    promptOnClose();
    promptOnContinue();
  };

  const HandleDataLayer = (
    event: string,
    action: string,
    name: string,
    type: string,
    region: string,
    section: string,
    text: string,
    component?: string
  ) => {
    generateGtmEvent({ event, action, name, type, region, section, text, component });
  };

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="sm"
        classes={{
          paper: classes.newPosOfDialog,
        }}
        onClose={handleDismissPrompt}
        aria-labelledby="simple-dialog-title"
        open={promptOpen}>
        <Typography variant="h4" className={classes.dialogTitle}>
          You haven’t gotten credit yet.
        </Typography>
        <Typography variant="body2" className={classes.dialogText}>
          In order to get credit for your work, press the ’Submit’ button to submit your
          answer for grading.
        </Typography>
        <Stack direction="row" justifyContent="space-between">
          <Button
            onClick={() => {
              HandleDataLayer(
                "link",
                "click",
                "onclick",
                "internal link",
                "modal",
                "You haven’t gotten credit yet.",
                "back to problem"
              );
              handleDismissPrompt();
            }}
            variant="contained"
            color="primary"
            size="large"
            className={classes.buttonNo}>
            Back to problem
          </Button>
          <Button
            onClick={() => {
              HandleDataLayer(
                "link",
                "click",
                "onclick",
                "internal link",
                "modal",
                "You haven’t gotten credit yet.",
                "next problem"
              );
              handleContinue();
            }}
            variant="contained"
            color="primary"
            size="large"
            className={classes.buttonYes}>
            Continue
          </Button>
        </Stack>
      </Dialog>
    </>
  );
};
